/* auteniQ · Kategorie-Kacheln auf dem Handy als Raster.
   Unterhalb von 921 px wird der Swiper abgebaut, damit alle Kacheln
   untereinander sichtbar sind; oberhalb wird er mit derselben
   Konfiguration wie in auteniq-category-menu.min.js wieder aufgebaut.
   Läuft nach dem Sektions-Skript (defer, Dokumentreihenfolge). */
(function () {
  'use strict';

  var GRENZE = 921;

  function abstand(root) {
    return parseFloat(getComputedStyle(root).getPropertyValue('--card-gap')) || 12;
  }

  function konfiguration(root) {
    return {
      slidesPerView: 'auto',
      spaceBetween: abstand(root),
      slidesPerGroupAuto: true,
      centerInsufficientSlides: true,
      a11y: {
        prevSlideMessage: 'Vorherige Kategorien',
        nextSlideMessage: 'Weitere Kategorien'
      },
      navigation: {
        prevEl: '[data-js-category-menu-prev]',
        nextEl: '[data-js-category-menu-next]',
        disabledClass: 'is-disabled'
      }
    };
  }

  function anwenden() {
    var mobil = window.innerWidth < GRENZE;
    document.querySelectorAll('[data-js-category-menu]').forEach(function (root) {
      var rail = root.querySelector('[data-js-swiper]');
      if (!rail) return;

      if (mobil) {
        root.classList.add('is-raster');
        if (rail.swiper && !rail.swiper.destroyed) rail.swiper.destroy(true, true);
        var nav = root.querySelector('[data-js-category-menu-nav]');
        if (nav) nav.hidden = true;
      } else {
        root.classList.remove('is-raster');
        if (!rail.swiper && typeof Swiper !== 'undefined') {
          try { new Swiper(rail, konfiguration(root)); } catch (e) {}
        }
      }
    });
  }

  var warten;
  window.addEventListener('resize', function () {
    clearTimeout(warten);
    warten = setTimeout(anwenden, 180);
  });

  function start() { setTimeout(anwenden, 0); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(anwenden, 80);
  });
})();
